<template>
    <div v-if="show" class="toast" :class="show ? 'show':'hide'" v-html="text">
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false,
            text: ''
        }
    },
    computed: {

    },
    methods: {
        open(text, autoHide = true) {
            this.text = text
            this.show = true
            if(autoHide) {
                setTimeout( () => {
                    this.close()
                }, 3000)
            }
        },
        close() {            
            this.show = false
            this.text = ''
        }
    },
    mounted() {
    }
}
</script>
<style scoped>
    .toast {
        position: fixed;
        left: 7.5vw;
        bottom: 12vh;
        width: 85vw;
        max-width: 500px;
        padding: 1.2vh;
        text-align: center;
        vertical-align: middle;
        font-size: 2vh;
        color: white;
        background-color: gray;
        border-radius: 5vh;
        z-index: 1000;
        line-height: 160%;
        word-break: keep-all;
    }

    @media screen and (min-width: 501px) {
        .toast {
            position:absolute;
            bottom: 12vh;
            left:50%;
            transform:translate(-50%, 0);
            width:500px;
        }
    }
    .toast.show {
        display: block;
        animation: fadein 0.5s;
    }
    .toast.hide {
        animation: fadeout 0.5s;
        
    }
    @keyframes fadein {
        from {
            opacity: 0;
            bottom: 0vh;
        }
        to {
            opacity: 1;
            bottom: 12vh;
        }
    }
    @keyframes fadeout {
        from {
            opacity: 1;
            bottom: 12vh
        }
        to {
            opacity: 0;
            bottom: 0vh;
            display: none;
        }
    }

</style>